import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import fileDownload from 'react-file-download';
import { failSelectionlists } from '../../store/orderlist/actions';
import { downloadPdf } from './downloadPdf';
import { disableListLoading, enableListLoading } from '../../store/listLoading/actions';

export const useDownloadPdf = ({ id, name }: { id: string; name: string }) => {
    const dispatch = useDispatch();

    return useMutation(() => downloadPdf(id), {
        onMutate: () => {
            dispatch(enableListLoading());
        },
        onSuccess: res => {
            dispatch(disableListLoading());
            fileDownload(res.data, `${name}.pdf`);
        },
        onError: error => {
            dispatch(disableListLoading());
            dispatch(failSelectionlists(error));
        }
    });
};
